import { render, staticRenderFns } from "./RevisionCardActions.vue?vue&type=template&id=e244a55a&scoped=true&"
import script from "./RevisionCardActions.vue?vue&type=script&lang=js&"
export * from "./RevisionCardActions.vue?vue&type=script&lang=js&"
import style0 from "./RevisionCardActions.vue?vue&type=style&index=0&id=e244a55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e244a55a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardActions,VIcon})
